import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { Calendar, MapPin, Clock } from "lucide-react";
import { Badge } from "../../../ui/badge.jsx";

import ActionButtons from "../molecules/ActionButtons.jsx";
import useEditableCollection from "../../../../Hooks/useEditableCollection.js";
import { useTranslation } from "react-i18next";

const SpaceCard = ({ spaceData, onDelete, onRedirect }) => {
  const { t } = useTranslation();

  const {
    isEditing,
    editedData,
    setEditedData,
    handleEdit,
    setIsEditing,
  } = useEditableCollection("spaces", spaceData);

  const type = "spaces";

  const handleDelete = (e) => {
    e.stopPropagation();
    if (onDelete) onDelete();
  };

  const handleRedirect = () => {
    if (!isEditing && onRedirect)
      onRedirect(type, spaceData.giftID, spaceData.spaceName);
  };

  const handleCancel = (e) => {
    e.stopPropagation();
    setIsEditing(false);
    setEditedData({
      spaceName: spaceData.spaceName || "",
    });
  };

  const [localSpaceData, setLocalSpaceData] = useState(spaceData);

  React.useEffect(() => {
    setLocalSpaceData(spaceData);
  }, [spaceData]);

  const onSave = async (e) => {
    const response = await handleEdit(e);
    if (response && response.updatedData) {
      setLocalSpaceData((prev) => ({
        ...prev,
        ...response.updatedData,
        spaceName: response.spaceName || response.updatedData.spaceName || prev.spaceName,
      }));
    }
  };

  return (
    <div
      className="bg-gradient-to-r from-red-50 to-grey-200 backdrop-blur-md rounded-2xl p-4 shadow-md border-1 max-w-60 min-h-40 w-full cursor-pointer flex flex-col h-full justify-center items-center"
      onClick={handleRedirect}
    >
      <div className="flex-grow flex justify-center items-center gap-1 mb-2 w-full ">
        <div className="w-full">
          {isEditing ? (
            <div
              onClick={(e) => e.stopPropagation()}
              className="justify-center items-center"
            >
              <input
                type="text"
                name="spaceName"
                value={editedData.spaceName}
                onChange={(e) => {
                  e.stopPropagation();
                  const { value } = e.target;
                  setEditedData((prev) => ({ ...prev, spaceName: value }));
                }}
                className="text-sm font-semibold mb-1 w-full bg-transparent border-b border-gray-300 focus:outline-none focus:border-blue-500"
              />
            </div>
          ) : (
            <div className="flex flex-wrap align-middle justify-center items-center">
              <h2 className="text-lg font-semibold mb-1 text-gray-800">
                {localSpaceData.spaceName}
              </h2>
            </div>
          )}
          <div className="flex gap-2 w-full flex-wrap mt-2 align-middle justify-center items-center">
            {localSpaceData.giftID && (
              <Badge className="text-xs font-semibold bg-gradient-to-r from-red-500/80 to-neutral-green-500/80 text-white px-2 py-1 rounded-full">
                {localSpaceData.giftID.length} {t("eventsAndSpaces.savedProducts")}
              </Badge>
            )}
          </div>
        </div>
      </div>
      <ActionButtons
        onEdit={onSave}
        onDelete={handleDelete}
        onCancel={handleCancel}
        isEditing={isEditing}
      />
    </div>
  );
};

export default SpaceCard;
